<div class="d-flex famnuts-decoupage cursorHelp" *ngIf="!utils.isCollectionNullOrEmpty(cellule.famillesGemrcn)">
  <div class="no-overflow" [escape]="false" [pTooltip]="tooltip()">{{label()}}</div>
</div>
